import { api } from '@cwd/lib/main';

export interface AccountFeatureItem {
    FeatureId: string;
    Name: string;
    IsDisabled: boolean;
}

export async function getAccountFeatures(accountId: string): Promise<AccountFeatureItem[]> {
    return api.get(`/BackOffice/Account/${accountId}/Features`);
}

export async function disableFeature(accountId: string, featureId: string): Promise<void> {
    return api.post(`/BackOffice/Account/${accountId}/Features/${featureId}/Disable`);
}

export async function enableFeature(accountId: string, featureId: string): Promise<void> {
    return api.delete(`/BackOffice/Account/${accountId}/Features/${featureId}/Disable`);
}
